import Svg, { Path, type SvgProps } from 'react-native-svg'

export function ChevronRight(props: SvgProps & { size?: number }) {
  const size = props.size ? props.size : 16
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        d="M6 12L9.79026 8.4714C10.0699 8.21106 10.0699 7.78894 9.79026 7.5286L6 4"
        stroke={props.stroke || (props.color ?? 'black')}
        strokeWidth={props.strokeWidth ?? '1.5'}
        strokeLinecap="round"
      />
    </Svg>
  )
}
